import { ModelSetTransformer, ModelTransformer } from '../common/common.model';
import { Util } from '../common/common.util';

export interface ExtCaoDetailsPopupItem {
    userName: string;
    expectedOps: number;
    metricID: number;
    metricName: string;
    variance_30Days: number;
    variance_Wtd: number;
    combinedVariance: number;
    startedOn: string;
    scorecardWeight: number;
    commitmentsRecorded: number;
    isCurrentOpportunity: number;
}

export interface CaoDetailsPopupItem {
    metricName: string;
    variance_30Days: number;
    variance_Wtd: number;
    combinedVariance: number;
    startedOn: Date;
    scorecardWeight: number;
}

export interface CaoDetailsPopup {
    expectedOps: number;
    items: CaoDetailsPopupItem[];
}

class CaoDetailsPopupItemModelTransformer
    implements ModelTransformer<CaoDetailsPopupItem, ExtCaoDetailsPopupItem>
{
    transform(model: ExtCaoDetailsPopupItem): CaoDetailsPopupItem {
        return {
            metricName: model.metricName,
            variance_30Days: model.variance_30Days,
            variance_Wtd: model.variance_Wtd,
            combinedVariance: model.combinedVariance,
            startedOn: Util.dateToDate(model.startedOn),
            scorecardWeight: model.scorecardWeight,
        };
    }
}

class CaoDetailsPopupItemModelSetTransformer extends ModelSetTransformer<
    CaoDetailsPopupItem,
    ExtCaoDetailsPopupItem
> {
    protected newTransformer(): ModelTransformer<
        CaoDetailsPopupItem,
        ExtCaoDetailsPopupItem
    > {
        return new CaoDetailsPopupItemModelTransformer();
    }
}

export class CaoDetailsPopupModelTransformer
    implements ModelTransformer<CaoDetailsPopup, ExtCaoDetailsPopupItem[]>
{
    transform(model: ExtCaoDetailsPopupItem[]): CaoDetailsPopup {
        const items = new CaoDetailsPopupItemModelSetTransformer().transform(
            model,
        );
        return {
            expectedOps: model.length === 0 ? 0 : model[0].expectedOps,
            items,
        };
    }
}

export function validateCaoDetailsPopup(model: CaoDetailsPopup): void {
    const valid =
        model != null &&
        model.expectedOps >= 0 &&
        model.items != null &&
        model.items.length !== 0;
    if (!valid) {
        throw new Error('CaoDetailsPopup not valid');
    }
}
